import session from "../../../services/session";
import swal from "sweetalert2";
import AdminApi from '../../../services/api'
import CONFIG_COMPANY from "../../../services/myConfig";
import Loc from "../../../services/localization";

const AdminApiService = new AdminApi();
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            companyName: '',
            model: {
                fromPeriod: null,
                toPeriod: null,
                itemCount: 0,
                itemPrice: 0,
                type: 'MINUS',
                company: ''
            },
            types: ['MINUS','PLUS'],

        }
    },
    methods: {
        addInvoice: addInvoice,
    },
    beforeMount() {
        if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.companyName = this.$route.query.companyName;

    }
}

function addInvoice() {
    let _self = this;
    if(_self.model.fromPeriod == null || _self.model.toPeriod == null || this.itemCount <= 0 || this.itemPrice <=0){
        swal(LocService.t("label_error"),LocService.t('label_invoice_all_field_required'), 'error')
        return;
    }

    _self.model.fromPeriod =_self.model.fromPeriod + 'T08:00:00.000Z';
    _self.model.toPeriod =_self.model.toPeriod + 'T08:00:00.000Z';
    _self.model.company = this.companyName;
    // _self.model.itemPrice = parseFloat(_self.model.itemPrice.toString())
    // _self.model.itemCount = parseFloat(_self.model.itemCount.toString())

    AdminApiService.addInvoice(_self.model)
        .then((response) => {
            swal(LocService.t("label_success"), LocService.t('label_payment_success_add'), 'success')
            this.$router.push('/invoices');
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}



// WEBPACK FOOTER //
// ./src/components/Invoice/Add/AddInvoice.js